import React from "react";
import { Link } from "react-router-dom";
import Context from "../../../Context";
import Blocker from "../../Misc/Blocker";
import DefaultNotFound from "../../Misc/DefaultNotFound";

export default class SpecItem extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      notFound: false,
      item: {},
      specTree: {},
      defaultNode: null,
    };
  }
  componentDidMount() {
    this.loadReferences().then(() => this.load());
  }
  componentDidUpdate(prevProps) {
    if (
      prevProps.itemId !== this.props.itemId ||
      prevProps.projectId !== this.props.projectId ||
      prevProps.shipId !== this.props.shipId
    ) {
      this.loadReferences().then(() => this.load());
    }
  }

  onChange = (id, value) => {
    this.setState((state) => {
      let { item } = state;
      item[id] = value;
      return { item };
    });
  };
  loadReferences = async () => {
    this.setState({ pending: true });
    let specTree = await this.context.api.qoo(
      `/specification/tree`,
      {
        ship: this.props.shipId,
        project: this.props.projectId,
        search: [
          {
            lstr: "(",
            field: "statetypecode",
            compare: "EQL",
            value: "enabled",
            rstr: ")",
          },
        ],
      },
      undefined,
      undefined,
      undefined,
      "node",
      "sequence"
    );

    this.setState({ pending: false, specTree });
  };
  loadNode = () => {
    let searchParams = new URLSearchParams(
      this.props.location.search.substr(1)
    );
    let node = searchParams.get("node");
    this.setState({ defaultNode: node || "" });
  };
  load = async () => {
    this.setState({ pending: true });
    let item = {};
    if (this.props.itemId !== "add") {
      item = await this.context.api.q("/specification/get", {
        id: this.props.itemId,
      });
    } else {
      item = {
        id: "add",
        visible: true,
      };
    }

    this.loadNode();
    this.setState({
      pending: false,
      item: item || {},
      notFound: item === false,
    });
  };

  save = async () => {
    const { item } = this.state;
    const { projectId, shipId } = this.props;
    const { nullUuid } = this.context.api;

    let id = item.id === "add" ? null : item.id;
    let ship = item.ship || null;
    let key = item.key || null;
    let sequence = item.sequence || null;
    let node = item.node || nullUuid;

    if (shipId && shipId !== nullUuid) {
      ship = shipId;
      if (item.id && item.id === item.key && !item.ship) {
        id = null;
        key = item.id;
      }
    }

    this.setState({ pending: true });
    let result = await this.context.api.q("/specification/set", {
      id,
      ship,
      key,
      sequence,
      project: this.props.projectId,
      name: item.name,
      node: node || nullUuid,
      description: item.description,
      visible: item.visible ? true : false,
    });
    this.setState({ pending: false });
    if (result !== false) {
      this.context.toast("Изменения сохранены", "success");
      if (item.id === "add") {
        this.context.redirect(`/spec/${projectId}/${shipId}/`);
      }
      if (this.props.onAfterSave) {
        this.props.onAfterSave(item);
      }
    } else {
      this.context.toast("Не удалось сохранить изменения", "error");
    }
  };

  render() {
    const { pending, item, notFound, defaultNode } = this.state;

    return (
      <>
        <Blocker hAuto on={pending}>
          {notFound && <DefaultNotFound />}
          {item.id && (
            <>
              <div className="pb-3"></div>

              {item.id === "add" ? (
                <h5 className="mb-5">Добавление узла</h5>
              ) : (
                <div className="d-flex justify-content-between">
                  <h5 className="mb-5">Редактирование узла</h5>
                  <div></div>
                </div>
              )}

              <div className="form-group">
                <label>Наименование</label>
                <input
                  disabled={!this.props.manage}
                  id="name"
                  value={item.name || ""}
                  onChange={(e) => this.onChange(e.target.id, e.target.value)}
                  type="text"
                  className="form-control"
                />
              </div>
              <div className="form-group">
                <label>Родитель</label>
                <select
                  disabled={!this.props.manage}
                  id="node"
                  value={item.node || ""}
                  onChange={(e) => this.onChange(e.target.id, e.target.value)}
                  className="form-control"
                >
                  <option value=""></option>
                  {Object.entries(this.state.specTree).map(([id, item]) => (
                    <option value={item.id} key={id}>
                      {" . . ".repeat(item.level)} {item.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label>Описание</label>
                <input
                  disabled={!this.props.manage}
                  id="description"
                  value={item.description || ""}
                  onChange={(e) => this.onChange(e.target.id, e.target.value)}
                  type="text"
                  className="form-control"
                />
              </div>

              <div className="form-group">
                <label className="checkbox">
                  <input
                    type="checkbox"
                    onChange={(e) => this.onChange("visible", !item.visible)}
                    checked={item.visible ? true : false}
                  />
                  <span className="mr-2"></span>
                  Показывать этот узел
                </label>
              </div>

              <div className="mb-4 py-2 border-bottom"></div>
              {this.props.manage && (
                <div className="d-flex justify-content-between">
                  <div>
                    <button onClick={this.save} className="btn btn-primary">
                      Сохранить
                    </button>
                  </div>
                  <div></div>
                </div>
              )}
            </>
          )}
        </Blocker>
      </>
    );
  }
}
